export const SB_PLACEMENT_ROW_NAMES = {
  TOP_OF_SEARCH: "Top of Search",
  OTHER_THAN_TOP: "Other than Top of Search",
  AUDIENCE: "Audience",
} as const

export const SB_PLACEMENT_ENUM_MATCHERS: Record<string, string[]> = {
  [SB_PLACEMENT_ROW_NAMES.TOP_OF_SEARCH]: ["TOP"],
  [SB_PLACEMENT_ROW_NAMES.OTHER_THAN_TOP]: ["HOME", "OTHER", "DETAIL", "PRODUCT", "REST"],
}

export const SB_DEFAULT_PLACEMENT_ENUMS: Record<string, string> = {
  [SB_PLACEMENT_ROW_NAMES.TOP_OF_SEARCH]: "TOP_OF_SEARCH",
  [SB_PLACEMENT_ROW_NAMES.OTHER_THAN_TOP]: "OTHER",
}

export const SB_TOP_OF_SEARCH_WRITE_ENUMS = ["TOP_OF_SEARCH"]

export const SB_OTHER_THAN_TOP_WRITE_ENUMS = ["HOME", "OTHER", "DETAIL_PAGE"]

export const SB_PLACEMENT_MODIFIER_LIMITS = {
  TOP_OF_SEARCH_MIN: 0,
  OTHER_THAN_TOP_MIN: -99,
  AUDIENCE_MIN: 0,
  MAX: 900,
} as const

// Order-count tiers capping the auto-SUGGESTED placement modifier.
// 11+ orders falls through to SB_PLACEMENT_MODIFIER_LIMITS.MAX.
export const SB_MODIFIER_ORDER_TIERS = [
  { maxOrders: 5, maxModifier: 10 },
  { maxOrders: 10, maxModifier: 50 },
] as const
